module.exports = __webpack_public_path__ + "static/img/2016-B.217341c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2016-B.png
// module id = KMkj
// module chunks = 1